import { inject, injectable } from 'inversify'
import { PlayerModule } from '@/app/api';
import { InteractionStateService, InteractionStateServiceSymbol } from './service'

@injectable()
export class InteractionPlayerModule implements PlayerModule {
  readonly name = 'interaction'
  
  constructor(
    @inject(InteractionStateServiceSymbol)
    private interactionService: InteractionStateService) {}

  start(): void {
    this.interactionService.start()
  }

  reset(): void {
  }

  async stop() {
    await this.interactionService.stop()
  }
}
